/*The id's contained in this file are for use with matching up the proper 
letter templates with their respective options*/

export const checkerOptionId = 1;
export const dataTranscriberOptionId = 2;
export const farsOptionId = 3;
export const keywordsOptionId = 4;
export const spotMappingOptionId = 5;
export const transcribeValidationOptionId = 6;
export const locationReviewId = 7;
export const matchingQueueId = 8;
export const managementQueueId = 9;
export const dataEntryOptionId = 10;
